module.exports = __webpack_public_path__ + "img/community-feature-2.741103b2.svg";